import { PreviewContentContainer } from 'modules/templateEditor/EditEmail/preview/styles';
import { InAppPreviewContentContainer } from 'modules/templateEditor/EditInApp/preview/styles';
import { SMSPreviewContainer } from 'modules/templateEditor/EditSMS/preview/styles';
import { WebPushPreviewContainer } from 'modules/templateEditor/EditWebPush/preview/styles';
import { PreviewContainer, PreviewContent } from 'modules/templateEditor/common';
import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';
import { StyledOptions } from 'ui/actionMenu/ActionMenu.styles';
import { SecondaryButton } from 'ui/button';
import { body2, colors, spacing, subtleShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customStyling = {
  p14: pxToRem(14),
};

export const Banner = styled.div`
  ${body2}
  display: flex;
  justify-content: center;
  padding: ${spacing.threeQuarter};
  background-color: ${colors.grey5};
`;

export const PreviewSection = styled.div`
  ${PreviewContainer} {
    max-width: 100%;
  }
  ${PreviewContentContainer} {
    padding: ${spacing.base} ${spacing.plusHalf} ${spacing.plusHalf};
  }
  ${PreviewContent} {
    padding-top: ${spacing.base};
  }
  ${InAppPreviewContentContainer} {
    padding-top: ${spacing.base};
  }
  ${WebPushPreviewContainer} iframe {
    padding: ${spacing.threeQuarter} ${customStyling.p14} ${spacing.plusHalf};
  }
  ${SMSPreviewContainer} iframe {
    padding-top: ${spacing.threeQuarter};
  }
`;

export const ContentActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const ButtonText = styled.div`
  padding-left: ${spacing.half};
`;

export const ComboButton = styled.div`
  display: flex;
  > button:first-child {
    border-right: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  > *:last-child > button {
    border-left: none;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
`;

export const Divider = styled.div`
  background-color: ${colors.grey15};
  box-shadow: ${subtleShadow.boxShadow};
  width: ${spacing.single};
`;

export const StyledActionMenu = styled(ActionMenu)`
  a {
    display: inline-flex;
    gap: ${spacing.half};
  }

  button {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;

export const ContentActionOverflowMenu = styled(ActionMenu)`
  a {
    display: inline-flex;
    gap: ${spacing.half};
  }

  ${StyledOptions} {
    padding: ${spacing.half};
  }
`;

export const ContentActionTriggerButton = styled(SecondaryButton)`
  padding: 0 ${spacing.half};
`;
